import React from "react";
import { AsyncButtonProps } from "./types";
import { Button, ButtonProps } from "@origin-digital/ods-core";

export function AsyncButton<T = unknown>({
  onHandleClick,
  onResult,
  onError,
  ...props
}: AsyncButtonProps<T>) {
  const [buttonStatus, setButtonStatus] =
    React.useState<ButtonProps["status"]>();

  const handleClick = React.useCallback(async () => {
    setButtonStatus("loading");
    try {
      const result = await onHandleClick();
      onResult?.(result);
    } catch (err) {
      onError?.(err);
    } finally {
      setButtonStatus(undefined);
    }
  }, [setButtonStatus, onHandleClick, onResult, onError]);

  return <Button {...props} onClick={handleClick} status={buttonStatus} />;
}
